export class Lead {
    public DS_ORIGEM: string = ''
    public NM_LEAD: string = ''
    public DS_EMAIL: string = ''
    public NR_TELEFONE: string = ''
    public NM_PRIMEIRO_NOME: string = ''
    public NM_SOBRENOME_PAI: string = ''
    public NM_SOBRENOME_MAE: string = ''
    constructor(){}
  }